// Journal article enhancements shared by the Shopify article template and the local
// Journal routes: builds the "In this guide" list from the article's section headings
// and marks the section being read. The article stays fully readable without it.
export function enhanceJournal(root, { updateHash = true } = {}) {
  if (!root) return () => {};
  const toc = root.querySelector("[data-journal-toc]");
  const list = toc?.querySelector("ol");
  const headings = [...root.querySelectorAll(".journal-content h2[id]")];
  if (!toc || !list || headings.length < 2) return () => {};
  const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const controller = new AbortController();
  list.replaceChildren(...headings.map((heading, index) => {
    const item = document.createElement("li");
    const link = document.createElement("a");
    link.href = `#${heading.id}`;
    const number = document.createElement("span");
    number.textContent = String(index + 1).padStart(2, "0");
    link.append(number, document.createTextNode(heading.textContent.trim()));
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const section = heading.closest(".journal-section") ?? heading;
      section.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      heading.setAttribute("tabindex", "-1");
      heading.focus({ preventScroll: true });
      if (updateHash) history.replaceState(null, "", `#${heading.id}`);
    }, { signal: controller.signal });
    item.append(link);
    return item;
  }));
  toc.hidden = false;
  const links = [...list.querySelectorAll("a")];
  let observer;
  if ("IntersectionObserver" in window) {
    const visible = new Set();
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      const current = headings.findIndex((heading) => visible.has(heading.closest(".journal-section") ?? heading));
      links.forEach((link, index) => {
        const active = index === current;
        link.classList.toggle("is-active", active);
        if (active) link.setAttribute("aria-current", "location"); else link.removeAttribute("aria-current");
      });
    }, { rootMargin: "-20% 0px -55% 0px" });
    headings.forEach((heading) => observer.observe(heading.closest(".journal-section") ?? heading));
  }
  return () => { controller.abort(); observer?.disconnect(); };
}

enhanceJournal(document.querySelector('[data-journal-article]'), { updateHash: true });
